var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkout__body" }, [
    _vm.checkoutData.cart_items.length > 0
      ? _c(
          "div",
          {
            staticClass: "checkout__body__block",
            attrs: { id: "cart-overview" },
          },
          [
            _c("table", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.checkoutData.cart_items, function (item) {
                  return _c("tr", { key: item.key }, [
                    _c("td", { attrs: { id: "name" } }, [
                      _vm._v(_vm._s(item.session_name)),
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { id: "status" } }, [
                      _vm._v(
                        _vm._s(
                          item.is_definitive == true
                            ? "Definitief"
                            : "Voorlopig"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { id: "type" } }, [
                      _vm._v(_vm._s(_vm.ucFirst(item.session_type))),
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { id: "date" } }, [
                      _vm._v(_vm._s(_vm.stringToDate(item.date))),
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { id: "timespan" } }, [
                      _vm._v(_vm._s(_vm.formattedTimespan(item))),
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { id: "price" } }, [
                      _vm._v(
                        _vm._s(_vm.$root.moneyFormat(item.product_price, 0))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "product-remove",
                      attrs: { id: "trash" },
                      domProps: { innerHTML: _vm._s(item.remove_dom_object) },
                    }),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "coupon-form__wrapper" },
              [
                _c("div", { staticClass: "has-coupon__wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hasCoupon,
                        expression: "hasCoupon",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "has-coupon",
                      id: "has-coupon",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.hasCoupon)
                        ? _vm._i(_vm.hasCoupon, null) > -1
                        : _vm.hasCoupon,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.hasCoupon,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.hasCoupon = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.hasCoupon = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.hasCoupon = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "has-coupon" } }, [
                    _vm._v("Vul klantcode in"),
                  ]),
                ]),
                _vm._v(" "),
                _c("Transition", { attrs: { mode: "out-in", name: "view" } }, [
                  _vm.hasCoupon
                    ? _c("div", { key: "form", staticClass: "coupon-form" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.coupon,
                              expression: "coupon",
                            },
                          ],
                          staticClass: "coupon-input",
                          attrs: {
                            type: "text",
                            placeholder: "Couponcode",
                            name: "coupon",
                            disabled: _vm.couponApplied,
                          },
                          domProps: { value: _vm.coupon },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.coupon = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "coupon-form__buttons" }, [
                          _c(
                            "span",
                            {
                              staticClass: "coupon-apply",
                              on: { click: _vm.applyCoupon },
                            },
                            [_vm._v("Toepassen")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "coupon-edit",
                              on: { click: _vm.editCoupon },
                            },
                            [_vm._v("Bijwerken")]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("Transition", { attrs: { mode: "out-in", name: "view" } }, [
                  _vm.couponError && _vm.hasCoupon
                    ? _c("span", { key: "error", staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.couponError)),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.checkoutData.cart_items.length > 0
      ? _c("div", { staticClass: "checkout__body__sidebar" }, [
          _c("h3", [_vm._v("Totale kosten")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "checkout__body__section" },
            [
              _c("div", { staticClass: "checkout__row" }, [
                _c("h5", [_vm._v("Aantal trainingen")]),
                _vm._v(" "),
                _c("h5", {
                  domProps: {
                    textContent: _vm._s(_vm.checkoutData.cart_items.length),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "checkout__row" }, [
                _c("h5", [_vm._v("Subtotaal")]),
                _vm._v(" "),
                _c("h5", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$root.moneyFormat(
                        _vm.checkoutData.total_cart_price_excl_tax
                      )
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _vm._l(_vm.coupons, function (coupon) {
                return _vm.coupons.length > 0
                  ? _c("div", { staticClass: "checkout__row" }, [
                      _c("h5", [
                        _vm._v("Kortingsbon: " + _vm._s(coupon.code) + " "),
                        _c("br"),
                        _vm._v(" "),
                        _c("a", { attrs: { href: coupon.remove_url } }, [
                          _vm._v("[Verwijderen]"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h5", {
                        domProps: {
                          innerHTML: _vm._s(
                            "- " +
                              _vm.$root.moneyFormat(parseFloat(coupon.discount))
                          ),
                        },
                      }),
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.tax > 0
                ? _c("div", { staticClass: "checkout__row" }, [
                    _c("h5", [_vm._v("BTW (21%)")]),
                    _vm._v(" "),
                    _c("h5", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.$root.moneyFormat(parseFloat(_vm.tax))
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "checkout__row", attrs: { id: "total-price" } },
                [
                  _c("h5", [_vm._v("Totaal")]),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$root.moneyFormat(parseFloat(_vm.totalPrice)))
                    ),
                  ]),
                ]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout__primary-button",
              attrs: { id: "next-step" },
              on: { click: _vm.nextPage },
            },
            [
              _c("span", [_vm._v("Volgende stap")]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  attrs: {
                    fill: "none",
                    height: "13",
                    viewBox: "0 0 9 13",
                    width: "9",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M0.357846 12.3798C0.454056 12.4298 0.562077 12.4527 0.670315 12.446C0.778554 12.4393 0.882922 12.4032 0.972219 12.3417L8.70392 6.989C8.78292 6.93426 8.84748 6.86119 8.89208 6.77605C8.93667 6.69091 8.95996 6.59623 8.95996 6.50012C8.95996 6.404 8.93667 6.30932 8.89208 6.22418C8.84748 6.13904 8.78292 6.06597 8.70392 6.01123L0.972219 0.658521C0.882991 0.596782 0.778575 0.560628 0.670274 0.553976C0.561974 0.547323 0.453918 0.570424 0.357805 0.620778C0.261691 0.671131 0.181185 0.746819 0.125001 0.839645C0.0688181 0.93247 0.0390991 1.0389 0.0390625 1.1474V11.8528C0.0390446 11.9614 0.0687421 12.0679 0.124936 12.1608C0.18113 12.2537 0.261677 12.3294 0.357846 12.3798Z",
                      fill: "white",
                    },
                  }),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.checkoutData.cart_items.length == 0
      ? _c(
          "div",
          {
            staticClass: "checkout__body__block",
            attrs: { id: "no-sessions" },
          },
          [
            _c("h3", [_vm._v("U heeft geen trainingen in uw winkelwagen!")]),
            _vm._v(" "),
            _vm._m(2),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Training")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", [_vm._v("Soort")]),
        _vm._v(" "),
        _c("th", [_vm._v("Datum")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tijd")]),
        _vm._v(" "),
        _c("th", [_vm._v("Kosten")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "/online-trainingen" } }, [
      _c("div", { staticClass: "checkout__secondary-button" }, [
        _c("span", [_vm._v("Meer trainingen boeken")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "/online-trainingen" } }, [
      _c("div", { staticClass: "checkout__primary-button" }, [
        _c("span", [_vm._v("Een training boeken")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/Views/CartView.vue